export class ProductForm extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['submit']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))

    this.handlePurpleDotShippingInfo()
    this.setupPreorderWatcher()
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  async onSubmitHandler (e) {
    e.preventDefault()

    await this.addToCart()
  }

  async addToCart () {
    return window.BAO.Cart.addItemFromForm(this.form)
  }

  handlePurpleDotShippingInfo () {
    const observerConfig = {
      childList: true,
      subtree: true,
    }

    const deliveryNoteEl = document.querySelector(
      '[data-product-form-el="preorder-note"]',
    )
    if (!deliveryNoteEl) return

    const mutationObserver = new MutationObserver(
      this.handleMutationInjected.bind(this),
    )

    mutationObserver.observe(this, observerConfig)
  }

  handleMutationInjected (mutationsList, observer) {
    mutationsList.forEach((mutation) => {
      const addedNode = mutation.addedNodes[0]
      if (addedNode?.id === 'pd-waitlist-info') {
        const textEl = addedNode.querySelector('#pd-dispatch-date')
        const mainProduct = mutation.target.closest('.prd-Detail')
        if (!textEl || !mainProduct) return

        const el = document.createElement('p')
        el.classList.add('prd-Note_Text')
        el.innerText = textEl.innerText

        const deliveryNoteEl = document.querySelector(
          '[data-product-form-el="preorder-note"]',
        )

        deliveryNoteEl.insertAdjacentElement('beforeend', el)

        observer.disconnect()
      }
    })
  }

  setupPreorderWatcher () {
    const mainProductForm = this.form
    if (!mainProductForm) return

    const addToCartText = this.els.submit.element.querySelector(
      '[data-product-add-to-cart-text]',
    )

    this.preorderObserver = new MutationObserver(() => {
      this.enforcePreorderState(mainProductForm, addToCartText)
    })

    this.preorderObserver.observe(mainProductForm, {
      attributes: true,
      attributeFilter: ['class', 'data-is-preorder'],
    })

    if (addToCartText) {
      this.preorderObserver.observe(addToCartText, {
        attributes: true,
        attributeFilter: ['data-text'],
      })
    }

    this.enforcePreorderState(mainProductForm, addToCartText)
  }

  enforcePreorderState (mainProductForm, addToCartText) {
    if (!mainProductForm.hasAttribute('data-is-preorder')) return

    const shouldBePreorder = mainProductForm.dataset.isPreorder === 'true'
    const hasThemeClass = mainProductForm.classList.contains(
      'is-preorder-variant',
    )
    const hasPdClass = mainProductForm.classList.contains(
      'x-pd-atc-form--preorder',
    )

    const preOrderText = window.variantStrings?.preOrder || 'Pre-Order'
    const desiredText = shouldBePreorder
      ? preOrderText
      : this.els.submit.element.hasAttribute('disabled')
        ? window.variantStrings?.soldOut ||
          window.theme?.strings?.soldOut ||
          'Sold out'
        : window.variantStrings?.addToCart ||
          window.theme?.strings?.addToCart ||
          'Add to Bag'

    const textIsWrong =
      addToCartText &&
      ((shouldBePreorder && addToCartText.dataset.text !== preOrderText) ||
        (!shouldBePreorder && addToCartText.dataset.text === preOrderText))

    if (
      shouldBePreorder === hasThemeClass &&
      shouldBePreorder === hasPdClass &&
      !textIsWrong
    ) {
      return
    }

    this.preorderObserver?.disconnect()

    mainProductForm.classList.toggle('is-preorder-variant', shouldBePreorder)
    mainProductForm.classList.toggle(
      'x-pd-atc-form--preorder',
      shouldBePreorder,
    )

    if (addToCartText && textIsWrong) {
      addToCartText.dataset.text = desiredText
      this.els.submit.element.setAttribute('aria-label', desiredText)
    }

    this.preorderObserver?.observe(mainProductForm, {
      attributes: true,
      attributeFilter: ['class', 'data-is-preorder'],
    })

    if (addToCartText) {
      this.preorderObserver?.observe(addToCartText, {
        attributes: true,
        attributeFilter: ['data-text'],
      })
    }
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }
}

customElements.define('product-form', ProductForm)
